// extracted by mini-css-extract-plugin
module.exports = {"container":"Notification_container__2Ycj5","notification":"Notification_notification__1C7Ma","fadeIn":"Notification_fadeIn__26s0Q","icon":"Notification_icon__1Ehyz"};